<template>
    <footer class="DefaultFooter">
        <figure
            :data-bgset="image"
            class="DefaultFooter__image lazyload"
        />
        <div class="container flex-vertical-b z-index relative">
            <div class="grid">
                <div class="grid__item one-whole desk-one-quarter">
                    <HeaderLogo
                        width="150"
                        height="84"
                    />
                </div>
                <div class="grid__item one-whole desk-one-quarter">
                    <div class="DefaultFooter__list">
                        <BaseHeading
                            heading="Travel Information"
                            tag="h4"
                        />
                        <ul>
                            <li
                                v-for="item in travelInformation"
                                :key="item.id"
                            >
                                <a :href="item.url">
                                    {{ item.heading }}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="grid__item one-whole desk-one-quarter">
                    <div class="DefaultFooter__list">
                        <BaseHeading
                            heading="Corporate"
                            tag="h4"
                        />
                        <ul>
                            <li
                                v-for="item in corporate"
                                :key="item.id"
                            >
                                <a :href="item.url">
                                    {{ item.heading }}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="grid__item desk-one-quarter">
                    <BaseButton
                        :href="buttonLink"
                        modifier="grey"
                    >
                        {{ buttonText }}
                    </BaseButton>

                    <SocialLinks
                        :items="social"
                    />
                </div>
            </div>
            <ul class="DefaultFooter__bottom">
                <li
                    v-for="item in bottom"
                    :key="item.id"
                >
                    <a :href="item.url">
                        {{ item.heading }}
                    </a>
                </li>
            </ul>
        </div>
    </footer>
</template>
<script>
export default {
    name: 'DefaultFooter',
    props: {
        image: {
            type: String,
            default: null
        },
        corporate: {
            type: Array,
            default: null
        },
        bottom: {
            type: Array,
            default: null
        },
        travelInformation: {
            type: Array,
            default: null
        },
        social: {
            type: Array,
            default: null
        },
        buttonText: {
            type: String,
            default: null
        },
        buttonLink: {
            type: String,
            default: null
        }
    }
}
</script>
<style lang="scss" scoped>

    ::v-deep .BaseHeading h4 {
        margin-bottom: getSpacing('base');
        font-size: 1rem;

        @include media-query(lap-and-up) {
            font-size: 1.1rem;
        }

        @include media-query(portable) {
            text-align: center;
        }
    }

    ::v-deep .HeaderLogo {
        @include media-query(portable) {
            display: block;
            text-align: center;
        }

        @include media-query(palm) {
            svg {
                width: 100px;
            }
        }
    }

    .DefaultFooter__list {
        @include media-query(portable) {
            text-align: center;
            margin: getSpacing('medium') 0;
        }

        li {
            font-size: 15px;
            margin-bottom: getSpacing('base');

            @include media-query(smart) {
                font-size: 13px;
            }
        }

        @include media-query(smart) {
            text-align: center;
        }
    }

    .SocialLinks {
        margin-top: getSpacing('large');

        @include media-query(portable) {
            justify-content: center;
            font-size: 1.5rem;
        }
    }

    .DefaultFooter__bottom {
        display: flex;
        align-items: center;
        font-weight: 700;
        font-size: 13px;
        color: getColor('white');
        padding-top: 300px;
        z-index: 1;
        justify-content: center;

        @include media-query(desk) {
            margin-left: -0.5rem;
            justify-content: flex-start;
            padding-top: 400px;
        }

        li {
            margin: 0 0.5rem;
        }
    }

    .BaseButton {
        @include media-query(portable) {
            display: block;
            margin: auto;
            max-width: 250px;
        }
    }


</style>
